module.exports = __webpack_public_path__ + "static/MUSICBG-24b869a0dad85aa43ad7b25ff0e08099.jpg";